module.exports = __webpack_public_path__ + "564c0ed17ccee2eaf9d9aed5ebc95152.pdf";